import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldComponent } from './form-field/form-field.component';
import { CharacterCounterComponent } from './character-counter/character-counter.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FormFieldComponent, CharacterCounterComponent],
  exports: [FormFieldComponent, CharacterCounterComponent],
})
export class LocalFormsModule {}
